import { HideIcon, ShowIcon } from '@carboncopyco/icons';
import type { IDynamicEditData } from '@carboncopyco/types';
import { ModificationItem } from './ModificationItem';
import { getVisibilityLabel } from './utils';

export const VisibilityModificationItem = ({
  edit,
}: {
  edit: IDynamicEditData['element'];
}) => {
  return (
    <ModificationItem>
      <ModificationItem.Content>
        <ModificationItem.Icon>
          {edit.new.value === 'true' ? (
            <HideIcon size={18} />
          ) : (
            <ShowIcon size={18} />
          )}
        </ModificationItem.Icon>
        <ModificationItem.Text label={getVisibilityLabel(edit)} />
      </ModificationItem.Content>
    </ModificationItem>
  );
};
